import { t } from '@lingui/core/macro';

import { Page, PageDateRangeFilter, PageFilterProvider } from '@/components/page';
import { exampleAIQuestions } from '@/constants/exampleAIQuestions';

import ChannelOverviewActions from './ChannelOverviewActions';
import ChannelOverviewKPIMetrics from './ChannelOverviewKPIMetrics';
import ChannelsSpendPerVisitChart from './ChannelsSpendPerVisitChart';
import ChannelsTrafficBreakdownChart from './ChannelsTrafficBreakdownChart';

const ChannelOverview = () => {
  return (
    <Page
      title={t`Channels`}
      pageName={t`All Channels`}
      exampleAIQuestions={exampleAIQuestions('channel')}
    >
      <PageFilterProvider>
        <div className="flex w-full flex-col gap-6">
          <div className="flex justify-between">
            <PageDateRangeFilter />
            <ChannelOverviewActions />
          </div>
          <ChannelOverviewKPIMetrics />
          <ChannelsTrafficBreakdownChart />
          <ChannelsSpendPerVisitChart />
        </div>
      </PageFilterProvider>
    </Page>
  );
};

export default ChannelOverview;
